<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 系统管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>提成核定</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-input v-model="query.userName" placeholder="用户名" class="handle-input mr10"></el-input>
				<el-input v-model="query.realName" placeholder="真实姓名" class="handle-input mr10"></el-input>
				<el-input v-model="query.tel" placeholder="联系电话" class="handle-input mr10"></el-input>
				&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="userName" label="用户名"></el-table-column>
                <el-table-column prop="realName" label="真实姓名"></el-table-column>
				<el-table-column prop="tel" label="联系电话"></el-table-column>
				<el-table-column prop="post" label="职务"></el-table-column>
				<el-table-column prop="role" label="角色" :formatter = "roleFormat"></el-table-column>
				<el-table-column prop="departmentId" label="部门" width = "200px" :formatter = "departmentFormat"></el-table-column>
				<el-table-column prop="status" label="状态" :formatter = "statusFormat"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" width = "160px"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['set']"
                        >设定</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="40%">
            <el-form ref="form" :model="form" label-width="150px" :rules="rules">
				<el-form-item label="用户名" prop="userName">
					{{form.userName}}
                </el-form-item>
				<el-form-item label="真实姓名" prop="realName">
					{{form.realName}}
                </el-form-item>
				<el-form-item label="个人提成计算方式" prop="businessCalculationMethod">
					<el-select v-model="form.businessCalculationMethod">
						<el-option :key="0" label="销售额" :value="0"></el-option>
						<el-option :key="1" label="利润" :value="1"></el-option>
					</el-select>
                </el-form-item>
				<el-form-item label="个人销售责任额" prop="businessLiabilityAmount" v-if="form.businessCalculationMethod == 0">
                    <el-input v-model="form.businessLiabilityAmount" placeholder="个人销售责任额，不设责任额则为0.00"></el-input>
                </el-form-item>
				<el-form-item label="业务提成比例" prop="businessCommissionScale">
                    <el-input v-model="form.businessCommissionScale" placeholder="占个人业务收入的比例，范围(0-0.8)"></el-input>
                </el-form-item>
				<el-form-item label="管理销售责任额" prop="manageLiabilityAmount">
                    <el-input v-model="form.manageLiabilityAmount" placeholder="管理销售责任额，不设责任额则为0.00"></el-input>
                </el-form-item>
				<el-form-item label="管理提成比例" prop="manageCommissionScale">
                    <el-input v-model="form.manageCommissionScale" placeholder="占组员业务收入的比例，范围(0-0.5)"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchUserData, saveUserTreatment, getUserTreatment, getApplyCompanyList, 
getEnumValueKV, getDepartmentTreeData} from '../../../api/index';
export default {
    name: 'commission-approved',
    data() {
		let checkBusinessCommissionScale = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('业务提成比例不能为空'));
			} else if (parseFloat(value) < 0 || parseFloat(value) > 0.8) {
				callback(new Error('设定的值超出了范围，范围(0-0.8)'))
			} else {
				callback();
			}
		};
		let checkManageCommissionScale = (rule, value, callback) => {
			if (value === '') {
				callback();
			} else if (parseFloat(value) < 0 || parseFloat(value) > 0.5) {
				callback(new Error('设定的值超出了范围，范围(0-0.5)'))
			} else {
				callback();
			}
		};
        return {
            query: {
                companyCode: '',
                userName: '',
                pageNum: 1,
                pageSize: 10
            },
			enumValueKV:[],
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			title:"",
			isDisabled:false,
			rules: {
				businessCalculationMethod: [{ required: true, message: '请选择个人提成计算方式', trigger: 'blur' }],
                businessLiabilityAmount: [{ required: true, pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/, message: '请输入正确的个人销售责任额', trigger: 'blur' }],
				businessCommissionScale: [{ required: true, validator: checkBusinessCommissionScale, trigger: 'blur' }],
				manageLiabilityAmount: [{ required: true, pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/, message: '请输入正确的管理销售责任额', trigger: 'blur' }],
				manageCommissionScale: [{ required: true, validator: checkManageCommissionScale, trigger: 'blur' }]				
            },
			controll:{},
			departmentMapping:{}
        };
    },
    created() {
		this.controll = getControll("commission-approved");
		this.getDepartmentData();
        this.getData();
    },
    methods: {
		//状态格式化
		statusFormat(row, column, cellValue) {
			if (cellValue == '0') {
				return '禁用';
			} else {
				return '启用';
			}
		},
		roleFormat(row, column, cellValue) {
			if (cellValue == '1') {
				return '企业管理员';
			} else if (cellValue == '2'){
				return '业务管理员';
			} else {
				return '一般用户';
			}
		},
		getDepartmentData() {
            getDepartmentTreeData().then(res => { 
				if (res.code == 0 ) {
					this.getDepartmentMapping(res.data, undefined);
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
		getDepartmentMapping(nodes, parentMapping) {
			for(let i = 0; i < nodes.length; i++) {
				let node = nodes[i]
				let mapping = {}
				if (parentMapping) {
					mapping["firstParentId"] = parentMapping["firstParentId"];
					mapping["name"] = parentMapping["name"] + " / " + node.label
				} else {
					mapping["firstParentId"] = node.id;
					mapping["name"] = node.label
				}
				this.departmentMapping[node.id] = mapping
				if (node.children && node.children.length > 0) {
					this.getDepartmentMapping(node.children, mapping)
				}
			}
		},
		departmentFormat(row, column, cellValue) {
			if (cellValue == "" || cellValue == undefined) {
				return "";
			}
			if (this.departmentMapping[cellValue]) {
				return this.departmentMapping[cellValue]["name"];
			} else {
				return "";
			}
		},
		//获取枚举
		onChangeGroupType(value) {
			this.enumValueKV = [];
			if (!value) {
				return;
			}
			getEnumValueKV(value).then(res => {
				if (res.code == 0 ) {
					this.enumValueKV = res.data;
				} else {
					this.$message.error("获取分组失败！" + res.message);
				}
			});
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchUserData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
			this.title = "编辑";
			getUserTreatment(row.id).then(res => {
				if (res.code == 0) {
					this.onChangeGroupType(res.data.enumCode);
					this.form = res.data;
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					let treatment = {};
					treatment["id"] = this.form.id;
					treatment["businessCalculationMethod"] = this.form.businessCalculationMethod;
					treatment["businessLiabilityAmount"] = this.form.businessLiabilityAmount;
					treatment["businessCommissionScale"] = this.form.businessCommissionScale;
					treatment["manageLiabilityAmount"] = this.form.manageLiabilityAmount;
					treatment["manageCommissionScale"] = this.form.manageCommissionScale;
					saveUserTreatment(treatment).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 180px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
